import { render, staticRenderFns } from "./SurveyCosts.vue?vue&type=template&id=453a59d8&scoped=true&"
import script from "./SurveyCosts.vue?vue&type=script&lang=js&"
export * from "./SurveyCosts.vue?vue&type=script&lang=js&"
import style0 from "./SurveyCosts.vue?vue&type=style&index=0&id=453a59d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a59d8",
  null
  
)

export default component.exports